var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, contain, disableEnd, disableStart, index, length, partner_show, undefined) {
buf.push("<div class=\"mgr-cells js-mgr-cells\">");
// iterate partner_show.install_shots
;(function(){
  var $$obj = partner_show.install_shots;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var installShot = $$obj[$index];

if ( installShot.carousel_dimension && installShot.url)
{
buf.push("<div class=\"mgr-cell js-mgr-cell\"><img" + (jade.attr("src", installShot.url, true, true)) + (jade.attr("alt", installShot.caption, true, true)) + (jade.attr("title", installShot.caption, true, true)) + ">");
if ( installShot.caption)
{
buf.push("<div" + (jade.attr("style", "width: " + (installShot.carousel_dimension.width) + "px", true, true)) + " class=\"show-installation-shot-caption\">" + (jade.escape(null == (jade_interp = installShot.caption) ? "" : jade_interp)) + "</div>");
}
buf.push("</div>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var installShot = $$obj[$index];

if ( installShot.carousel_dimension && installShot.url)
{
buf.push("<div class=\"mgr-cell js-mgr-cell\"><img" + (jade.attr("src", installShot.url, true, true)) + (jade.attr("alt", installShot.caption, true, true)) + (jade.attr("title", installShot.caption, true, true)) + ">");
if ( installShot.caption)
{
buf.push("<div" + (jade.attr("style", "width: " + (installShot.carousel_dimension.width) + "px", true, true)) + " class=\"show-installation-shot-caption\">" + (jade.escape(null == (jade_interp = installShot.caption) ? "" : jade_interp)) + "</div>");
}
buf.push("</div>");
}
    }

  }
}).call(this);

buf.push("</div>");
length = partner_show.install_shots.length
buf.push("<nav class=\"mgr-navigation js-mgr-navigation\">");
index = index || 0
buf.push("<a" + (jade.attr("disabled", disableStart, true, true)) + " class=\"mgr-arrow-left icon-chevron-left js-mgr-prev\"></a><div class=\"mgr-dots\">");
if (!( contain))
{
// iterate new Array(length)
;(function(){
  var $$obj = new Array(length);
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var x = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, true)) + (jade.cls(['mgr-dot','js-mgr-select',(index === i ? 'is-active' : undefined)], [null,null,true])) + ">•</div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var x = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, true)) + (jade.cls(['mgr-dot','js-mgr-select',(index === i ? 'is-active' : undefined)], [null,null,true])) + ">•</div>");
    }

  }
}).call(this);

}
buf.push("</div><a" + (jade.attr("disabled", disableEnd, true, true)) + " class=\"mgr-arrow-right icon-chevron-right js-mgr-next\"></a></nav>");}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"contain" in locals_for_with?locals_for_with.contain:typeof contain!=="undefined"?contain:undefined,"disableEnd" in locals_for_with?locals_for_with.disableEnd:typeof disableEnd!=="undefined"?disableEnd:undefined,"disableStart" in locals_for_with?locals_for_with.disableStart:typeof disableStart!=="undefined"?disableStart:undefined,"index" in locals_for_with?locals_for_with.index:typeof index!=="undefined"?index:undefined,"length" in locals_for_with?locals_for_with.length:typeof length!=="undefined"?length:undefined,"partner_show" in locals_for_with?locals_for_with.partner_show:typeof partner_show!=="undefined"?partner_show:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;